<script>
  import { _ } from 'svelte-i18n'
  import Insert from '../../elements/Insert.svelte'
  import OpenBuyModalButton from '../../components/OpenBuyModalButton.svelte'

  export let insert_position
  export let inbetween_counter
</script>

{#if insert_position === 'before_previews'}
  <Insert {insert_position}>
    <span slot="toptitle">
      {$_('inserts.ads.topTitle') }
    </span>
    <span slot="title">
      {@html $_('inserts.ads.title') }
    </span>
    <span slot="text">
      { $_('inserts.ads.text') }
    </span>
    <span slot="button">
      <OpenBuyModalButton feature="ads">{@html $_('inserts.ads.buyButton') }</OpenBuyModalButton> 
      <small>{$_('inserts.ads.buttonInfo') }</small>
    </span>
  </Insert>
{/if}

{#if insert_position === 'between_previews'}
  {#if inbetween_counter=== 2}
    <Insert {insert_position}>
      <span slot="toptitle">
        {$_('inserts.ads.topTitle') }
      </span>
      <span slot="title">
        {@html $_('inserts.ads.titleUpgrade') }
      </span>
      <span slot="text">
        { $_('inserts.shared.thousands') }
      </span>
      <span slot="button">
        <OpenBuyModalButton feature="ads">{ $_('inserts.buttons.seePrice') }</OpenBuyModalButton> 
      </span>
    </Insert>
  {/if}
{/if}